import { Container, Header, Divider } from "semantic-ui-react";
import { CustomerManagerForm } from "../../../../Components/secure/customerManager/CustomerManagerForm";
import { RouteComponentProps, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface RouteParams {
  id: string;
}

export const EditCustomerManager: React.FC<RouteComponentProps<RouteParams>> = () => {
  const { id } = useParams<RouteParams>();
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h1">{t("CustomerManager.Edit")}</Header>
      <Divider />
      <CustomerManagerForm id={id} />
    </Container>
  )
}